import { Cultures } from '@ideals/types';

export const PrivacyPolicyUrl: Record<string, string> = {
  [Cultures.US]: 'https://www.idealsvdr.com/privacy/',
  [Cultures.BR]: 'https://pt.idealsvdr.com/politica-de-privacidade/',
  [Cultures.CN]: 'https://www.idealsvdr.cn/privacy/',
};
